var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPreview = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03937 8.54776C1.62533 8.54776 2.04545 8.11706 2.04545 7.52071V6.68139L1.83539 3.18056L4.47773 5.95251L7.61759 9.11099C7.80554 9.30977 8.05982 9.40917 8.33622 9.40917C8.9664 9.40917 9.43075 8.98951 9.43075 8.36002C9.43075 8.07289 9.32019 7.80784 9.12118 7.59801L5.97027 4.45058L3.1842 1.8222L6.71101 2.03203H7.56231C8.15933 2.03203 8.61262 1.61237 8.61262 1.01601C8.61262 0.419658 8.15933 0 7.56231 0H1.758C0.652416 0 0.00012207 0.64053 0.00012207 1.75594V7.52071C0.00012207 8.10602 0.442355 8.54776 1.03937 8.54776ZM12.4379 20H18.2422C19.3589 20 20.0001 19.3484 20.0001 18.2441V12.4793C20.0001 11.894 19.5689 11.4412 18.9719 11.4412C18.386 11.4412 17.9548 11.8829 17.9548 12.4793V13.3076L18.1759 16.8194L15.5336 14.0364L12.3937 10.878C12.1947 10.6792 11.9515 10.5798 11.6751 10.5798C11.0449 10.5798 10.5806 10.9994 10.5806 11.6289C10.5806 11.9271 10.6911 12.1922 10.8901 12.3909L14.041 15.5384L16.8271 18.1668L13.3003 17.9569H12.4379C11.852 17.9569 11.3987 18.3766 11.3987 18.9729C11.3987 19.5693 11.8409 20 12.4379 20Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPreview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-preview.4f779346b04175c669e4956897142a52.svg";